module.exports = __webpack_public_path__ + "img/main_image6.3cb5a59b.png";